export default __webpack_public_path__ + "static/media/4.1678b5d8.jpg";